module.exports = __webpack_public_path__ + "static/img/product_manufacture_UniStlDetection.0b5fbbf.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/product_manufacture_UniStlDetection.png
// module id = dZLH
// module chunks = 0